import { useRef } from 'react';
import { BsArrow90DegDown } from "@react-icons/all-files/bs/BsArrow90DegDown";
import { BsArrowReturnRight } from "@react-icons/all-files/bs/BsArrowReturnRight";
import { FiCheckCircle } from "@react-icons/all-files/fi/FiCheckCircle";
import { CgRadioCheck } from "@react-icons/all-files/cg/CgRadioCheck";
import { GrEdit } from "@react-icons/all-files/gr/GrEdit";
import { AiOutlineSave } from "@react-icons/all-files/ai/AiOutlineSave";
import { useDispatch } from "react-redux";

function Todo({ todoDetails: { id, name, description, startDate, endDate, completed, editMode, viewState } }) {
    const dispatch = useDispatch();

    const startDateEl = useRef("");
    const endDateEl = useRef("");

    const todaysDate = new Date().toISOString().split("T")[0];
    const chosenMaxDate = "2030-01-01";
    const startMinDate = todaysDate;
    const startMaxDate = chosenMaxDate;
    const endMinDate = todaysDate;
    const endMaxDate = chosenMaxDate;

    // splits the id string into 4 sections
    const idSectionLength = id.length / 4; // give length of each string when split into 4 sections
    const stringExp = new RegExp(`.{1,${idSectionLength}}`,"g");
    const idSections = id.match(stringExp); // array of size 4

    const handleCheckboxClick = () => {
        if (!viewState) return; // dont toggle if it is in "frozen" mode
        dispatch({type:'TOGGLE_TODO', payload: {id}});
    }

    const handleEditClick = () => {
        if (!viewState) return;
        dispatch({type:'TOGGLE_EDIT_TODO', payload: {id}});
    }

    const handleModify = (obj, elType = "") => {
        switch (elType) {
            // ensures start date and end date dont overlap in the wrong direction
            case "startDateEl":
                if (obj.startDate > endDate) obj = { ...obj, endDate: obj.startDate };
                break;
            case "endDateEl":
                if (obj.endDate < startDate) obj = { ...obj, startDate: obj.endDate };
                break;
            default: break;
        }
        dispatch({type:'MODIFY_TODO', payload: {id, newPropsObj:obj}});;
    }

    return (
        <div className={`todo ${editMode ? 'input' : ''} ${viewState ? 'view' : 'not-view'} ${completed ? 'completed' : 'uncompleted'}`} >
            <div className="todo-content">
                <div>
                    <label htmlFor={id+idSections[0]} className="no-display-form-label" >Task name</label>
                    <input id={id+idSections[0]} type="text" value={name} readOnly={!editMode} onChange={(e) => { handleModify({ name: e.target.value }) }} />
                </div>
                <div>
                    <label htmlFor={id+idSections[1]} className="no-display-form-label" >Description</label>
                    <textarea id={id+idSections[1]} type="textarea" value={description} readOnly={!editMode} onChange={(e) => { handleModify({ description: e.target.value }) }} />
                </div>
                <div className="startDateContainer">
                    <label htmlFor={id+idSections[2]} className="no-display-form-label" >Start date</label>
                    <BsArrow90DegDown />
                    <input id={id+idSections[2]} type="date" ref={startDateEl} min={startMinDate} max={startMaxDate} value={startDate} readOnly={!editMode} onChange={(e) => { handleModify({ startDate: e.target.value }, "startDateEl") }} />
                </div>
                <div className="endDateContainer">
                    <label htmlFor={id+idSections[3]} className="no-display-form-label" >End date</label>
                    <BsArrowReturnRight />
                    <input id={id+idSections[3]} type="date" ref={endDateEl} min={endMinDate} max={endMaxDate} value={endDate} readOnly={!editMode} onChange={(e) => { handleModify({ endDate: e.target.value }, "endDateEl") }} />
                </div>
            </div>
            <div className="edit-todo-control" >
                <div onClick={handleCheckboxClick} className={`toggle-checked-btn ${!completed && 'active'}`} title={completed ? "Mark as uncompleted" : "Mark as completed"}>
                    {!completed && <CgRadioCheck />}
                    {completed && <FiCheckCircle />}
                </div>
                <div onClick={handleEditClick} className={`toggle-edit-btn ${editMode && 'active'}`} title={editMode ? "Click to save" : "Click to edit"}>
                    {!editMode && <GrEdit />}
                    {editMode && <AiOutlineSave />}
                </div>
            </div>
        </div>
    );

}

export default Todo;